import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

function Title() {
  return (
    <div>
      <h2 className="font-semibold text-2xl leading-7 tracking-normal text-gray-900 mb-2">
        <T kind="Share with Participants" />
      </h2>
      <p className="font-normal text-sm leading-5 tracking-normal text-gray-600">
        <T kind="Choose how to share, then confirm more details in the next step." />
      </p>
    </div>
  );
}

export default observer(Title);
